import {AppProps} from "../App";
import axios from "axios";

export class PdfDataService {
    private static prependZero(num: number): string {
        if (num < 10) return "0" + num;
        return "" + num;
    }

    public static getDateString(language: 'de-DE' | 'en-US'): string {
        const date = new Date();
        switch (language) {
            case "de-DE": {
                return `${this.prependZero(date.getDate())}.${this.prependZero(date.getMonth()+1)}.${date.getFullYear()}`;
            }
            case "en-US": {
                return "TODO";
            }
        }
    }

    public static async getPdfData(): Promise<AppProps> {
        const url = new URL(window.location.href);
        const boothId = url.searchParams.get("booth");
        const boothTypeId = url.searchParams.get("type");
        const area = url.searchParams.get("area");
        const language = url.searchParams.get("language");
        const fair = url.searchParams.get("fair");

        axios.defaults.headers.get['Accept-Language'] = language;
        axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

        if(process.env.REACT_APP_DEV === "true") {
            const endpoint = process.env.REACT_APP_BFF;
            const data = await axios.get(`${endpoint}/pdf/booth/${boothId}/type/${boothTypeId}?area=${area}&language=${language}&fair=${fair}`);
            console.log(data.data);
            return data.data as any;
        }

        const data = await axios.get(`/pdf/booth/${boothId}/type/${boothTypeId}?area=${area}&language=${language}&fair=${fair}`)
        return data.data as any;
    }
}